import React from 'react';
import { FC, ReactElement } from 'react';
import Layout from '../components/Layout';
import { Outlet } from 'react-router-dom';

const LayoutRoutes: FC = (): ReactElement => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default LayoutRoutes;
